/**
 * Augments navigation routes with full paths.
 *
 * This behavior should be attached at the menu-item-view level.
 */

import Marionette from "backbone.marionette";

class Routable extends Marionette.Behavior {
  // will be called once per menu item with children
  onBeforeRenderCollection() {
    // clone the original collection
    const _coll = this.view.collection.clone();

    // clears the original collection
    this.view.collection.reset([], { silent: true });

    // find deleted, hidden and items that should not appear based on role
    const _deleted = _coll.where({ deleted: true });
    const _hidden = _coll.where({ hidden: true });
    const _invalidRole = _coll.where({ validRole: false });

    // when items need to be deleted
    if (_deleted.length + _hidden.length + _invalidRole.length) {
      // console.log("deleting", { _deleted, _hidden, _invalidRole });

      // remove those items from cloned collection
      _coll.remove(_deleted);
      _coll.remove(_hidden);
      _coll.remove(_invalidRole);
    }

    // get current route path
    const parentPath = this.view.model.get("path");

    // update collection paths
    _coll.map((model) => {
      // prefix models' paths with that of the parent
      const paths = [parentPath, model.get("path")];
      model.set("path", paths.join(""));

      // return updated model to collection
      return model;
    });

    // updates the original collection
    this.view.collection.reset(_coll.toJSON());

    // console.dir(this.view.collection.toJSON());
  }
}

export { Routable as default };
